import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { IpeBrandMark } from '@/components/ipe/IpeBrandLogo';
import IpeCreditsPurchaseView from '@/components/ipe/IpeCreditsPurchaseView';
import IpeRechargeCartButton from '@/components/ipe/IpeRechargeCartButton';
import { IPE_WORKBENCH_PATH } from '@/config/ipeRoutes';
import '@/styles/ipe/ipe-credits-purchase-modal.css';
import '@/styles/ipe/ipe-recharge-page.css';

function RechargeToast({ message, type, onDone }) {
  useEffect(() => {
    const timer = window.setTimeout(onDone, 2800);
    return () => window.clearTimeout(timer);
  }, [onDone]);

  return (
    <div className={`modern-toast modern-toast--${type}`} role="status">
      <span className="modern-toast__message">{message}</span>
    </div>
  );
}

export default function IpeRechargePage() {
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'success') => {
    setToast({ message, type });
  }, []);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(IPE_WORKBENCH_PATH);
  };

  return (
    <div className="ipe-recharge-page">
      <header className="ipe-recharge-page__topbar">
        <div className="ipe-recharge-page__topbar-start">
          <IpeBrandMark
            className="ipe-recharge-page__brand"
            textClassName="ipe-recharge-page__brand-text"
            text="IPE"
          />
          <button
            type="button"
            className="ipe-recharge-page__back"
            onClick={handleBack}
          >
            <ArrowLeft size={16} strokeWidth={2} aria-hidden="true" />
            返回工作台
          </button>
        </div>
        <div className="ipe-recharge-page__topbar-end">
          <IpeRechargeCartButton />
        </div>
      </header>

      <main className="ipe-recharge-page__main">
        <IpeCreditsPurchaseView showToast={showToast} />
      </main>

      {toast ? (
        <RechargeToast
          message={toast.message}
          type={toast.type}
          onDone={() => setToast(null)}
        />
      ) : null}
    </div>
  );
}
